import { render, staticRenderFns } from "./ReportSalesSummary.template.vue?vue&type=template&id=63d8f6e1&scoped=true&"
var script = {}
import style0 from "./ReportSalesSummary.template.vue?vue&type=style&index=0&id=63d8f6e1&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d8f6e1",
  null
  
)

export default component.exports